import { store, getContext, getElement } from "@wordpress/interactivity";

const { state } = store("filterable-crowd", {
  state: {
    get filteredProjects() {
      const { projects, activeStato, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();

      return projects.filter((p) => {
        if (activeStato !== "" && !p.stato_progetto.includes(activeStato))
          return false;
        if (q && !p.titolo.toLowerCase().includes(q)) return false;
        return true;
      });
    },

    get visibleIds() {
      return new Set(
        state.filteredProjects.slice(0, state.visibleCount).map((p) => p.id),
      );
    },

    get getItemDisplay() {
      const { projectId } = getContext();
      return state.visibleIds.has(projectId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.filteredProjects.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.filteredProjects.length > state.visibleCount
        ? "flex"
        : "none";
    },

    get dropdownLabel() {
      if (!state.activeStato) return state.dropdownLabelDefault;
      const found = state.stati.find((s) => s.value === state.activeStato);
      return found ? found.label : state.dropdownLabelDefault;
    },

    get isStatoActive() {
      const { statoValue } = getContext();
      return state.activeStato === statoValue;
    },
  },

  actions: {
    setStato() {
      const { statoValue } = getContext();
      state.activeStato = statoValue;
      state.visibleCount = state.perPage;
      state.dropdownOpen = false;
      updateURL();
    },

    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage;
      // replaceState: non crea una voce di cronologia per ogni tasto premuto
      updateURL({ replace: true });
    },

    toggleDropdown() {
      state.dropdownOpen = !state.dropdownOpen;
    },

    closeDropdownOutside(event) {
      if (!state.dropdownOpen) return;
      const { ref } = getElement();
      if (ref && !ref.contains(event.target)) state.dropdownOpen = false;
    },

    closeDropdownOnEsc(event) {
      if (event.key === "Escape") state.dropdownOpen = false;
    },

    loadMore() {
      state.visibleCount += state.perPage;
    },
  },
});

// ── Aggiorna l'URL con i filtri attivi ────────────────────────────────────
function updateURL({ replace = false } = {}) {
  const params = new URLSearchParams(window.location.search);

  if (state.activeStato) params.set("stato", state.activeStato);
  else params.delete("stato");

  const q = state.searchQuery.trim();
  if (q) params.set("q", q);
  else params.delete("q");

  const qs = params.toString();
  const newUrl = qs
    ? `${window.location.pathname}?${qs}`
    : window.location.pathname;

  history[replace ? "replaceState" : "pushState"](null, "", newUrl);
}

// ── Tasto indietro/avanti del browser ────────────────────────────────────
window.addEventListener("popstate", () => {
  const params = new URLSearchParams(window.location.search);

  const stato = params.get("stato") || "";
  state.activeStato = state.stati.some((s) => s.value === stato) ? stato : "";
  state.searchQuery = params.get("q") || "";
  state.visibleCount = state.perPage;
  state.dropdownOpen = false;
});
